import { FormDialog } from "@shared/features/form/FormDialog";
import { FieldType } from "@shared/features/form/Form";
import {
  title,
  description,
  successTitle,
  successDescription,
} from "../../friendInvitation.data";
import { useFriendInvitationForm } from "../../hooks/useFriendInvitationForm";

type Props = {
  onDone: () => void;
  onClose: () => void;
  isOpen: boolean;
  programId: number;
};

export function FriendInvitationFormDialog({
  onDone,
  onClose,
  programId,
}: Props) {
  const { fields, schema, handleSubmit } = useFriendInvitationForm({
    onSuccess: onDone,
    programId,
  });

  return (
    <FormDialog
      title={title}
      description={description}
      successTitle={successTitle}
      successDescription={successDescription}
      onSubmit={handleSubmit}
      onSecondaryClick={onClose}
      onClose={onClose}
      dialogName="invitationSend"
      schema={schema}
      fields={fields as FieldType[]}
      primaryButtonText={"Send"}
      secondaryButtonText={"Cancel"}
    />
  );
}

export default FriendInvitationFormDialog;
